<template>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-card>
                    <v-card-title>Przeprowadzone procedury</v-card-title>
                    <v-card-text>
                      <VisitProcedures :visitid="details.visitId" :items.sync="visitProcedures" :latest_procedures="details.latestProcedures"></VisitProcedures>
                    </v-card-text>
                  </v-card>

                </v-col>
              </v-row>
              <v-row v-if="isFizykoterapiaEnabled && (!details.zabiegId || details.zabiegId == 0)">
                <v-col cols="12">
                  <v-card>
                    <v-card-title>Zlecone zabiegi</v-card-title>
                    <v-card-text>
                      <TherapistZleconeZabiegi :vid="details.visitId" :data_wizyty="details.endTime"></TherapistZleconeZabiegi>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-btn
                                    absolute
                                    dark
                                    fab
                                    bottom
                                    right
                                    small
                                    depressed
                                    title="Skopiuj z poprzedniej wizyty"
                                    color="primary"
                                    @click="copyLatest()"
                                    v-if="details != null && details.latestProcess"
                            >
                                <v-icon>fa-plus</v-icon>
                            </v-btn>
                            <v-btn
                                    absolute
                                    dark
                                    fab
                                    bottom
                                    left
                                    small
                                    depressed
                                    title="Wybierz z bazy opisów"
                                    color="success"
                                    @click="showDescriptionPicker = true"
                                >
                                <v-icon>fa-database</v-icon>
                            </v-btn>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="12">
                                        <tiptap-vuetify v-model="process" name="process" 
                                                       @input="$emit('process', $event)"
                                                       :extensions="extensions"
                                                       :toolbar-attributes="{ color: 'primary' }"
                                                       placeholder="Badania/zabiegi..." />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
              <v-row>
                <v-dialog v-model="showDescriptionPicker" width="768">
                  <DescriptionPicker :type="2" @close="closingPicker" v-if="showDescriptionPicker"></DescriptionPicker>
                </v-dialog>
              </v-row>
            </v-container>

</template>

<script>
    import DescriptionPicker from "../descriptions/DescriptionPicker";
    import VisitProcedures from "@/components/visits/VisitProcedures";
    import TherapistZleconeZabiegi from "@/components/visits/TherapistZleconeZabiegi";
    import {mapState} from "vuex";
    import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Blockquote, HardBreak, History } from 'tiptap-vuetify'
    
    export default {
        name: "TherapistVisitProcess",
        components: {TherapistZleconeZabiegi, VisitProcedures, DescriptionPicker, TiptapVuetify},
        props: ['details', 'procedures'],
        data() {
            return {
                process: this.details != null ? this.details.process : null,
                showDescriptionPicker: false,
                extensions: [
                    History,
                    Blockquote,
                    Underline,
                    Strike,
                    Italic,
                    ListItem,
                    BulletList,
                    OrderedList,
                    [Heading, {
                        options: {
                            levels: [1, 2, 3]
                        }
                    }],
                    Bold,
                    Code,
                    Paragraph,
                    HardBreak
                ]
            }
        },
        methods: {
            closingPicker(desc)
            {
                if(desc != null)
                {
                    if(!this.process)
                    {
                        this.process = desc.description
                    }
                    else
                    {
                        this.process += "\r\n"+desc.description;
                    }
                }
                this.showDescriptionPicker = false
            },
            copyLatest() {
                if(this.process)
                    this.process += this.details.latestProcess
                else
                    this.process = this.details.latestProcess

                this.$emit('process', this.process)
            }
        },
      computed: {
        ...mapState('featuresModule',['features']),
        visitProcedures: {
          get: function() {
            return this.procedures ? this.procedures : []
          },
          set: function(val) {
            this.$emit('update:procedures',val)
          }
        },
        isFizykoterapiaEnabled: function() {
          return this.features && this.features.Fizykoterapia
        },
      }
    }
</script>

<style>

</style>